import * as React from "react";

import { Button } from "../../../ui/button";

interface ActionButtonsProps {
  isApplyDisabled: boolean;
  onCancel: () => void;
  onApply: () => void;
}

export function ActionButtons({ isApplyDisabled, onCancel, onApply }: ActionButtonsProps) {
  return (
    <div className="tw:flex tw:justify-end tw:gap-2">
      <Button variant="outline" onClick={onCancel}>
        Cancel
      </Button>
      <Button onClick={onApply} disabled={isApplyDisabled}>
        Apply
      </Button>
    </div>
  );
}
